import React from 'react';
import { SectionHeader, Card, Btn, HeaderBack } from '../components/UI';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

export default function ComingSoonPage({ moduleName: moduleNameProp }) {
  const navigate = useNavigate();
  const { projectId } = useParams();
  const [searchParams] = useSearchParams();
  const moduleName = moduleNameProp || searchParams.get('module') || 'This module';

  const isReportEntry = window.location.pathname.includes('/report-entry');
  const backPath = isReportEntry ? '/report-entry' : (projectId ? `/projects/${projectId}` : -1);
  const backLabel = isReportEntry ? 'Back to Report Entry' : 'Go Back';

  return (
    <div className="fade-in" style={{ padding: '24px 0', display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: '60vh' }}>
      {/* Back lives in the top bar. A module placeholder (no project, not a
          report-entry form) gets the route default — back to its parent card. */}
      {(isReportEntry || projectId) && <HeaderBack onClick={() => navigate(backPath)} label={backLabel} />}

      <Card style={{ 
        maxWidth: 500, 
        width: '100%', 
        padding: '60px 40px', 
        textAlign: 'center',
        background: 'linear-gradient(145deg, var(--bg-card) 0%, var(--bg-elevated) 100%)',
        border: '1px solid var(--accent)',
        boxShadow: '0 12px 40px rgba(0, 0, 0, 0.12)',
        borderRadius: 24,
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Decorative background element */}
        <div style={{
          position: 'absolute', top: -50, right: -50, width: 150, height: 150,
          background: 'var(--accent)', opacity: 0.1, borderRadius: '50%', filter: 'blur(30px)'
        }} />
        <div style={{
          position: 'absolute', bottom: -50, left: -50, width: 150, height: 150,
          background: 'var(--accent)', opacity: 0.05, borderRadius: '50%', filter: 'blur(30px)'
        }} />

        <div style={{ fontSize: 64, marginBottom: 20 }}>🚀</div>
        
        <h2 style={{ 
          fontSize: 28, 
          fontWeight: 800, 
          marginBottom: 16, 
          color: 'var(--text-primary)',
          letterSpacing: '-0.02em'
        }}>
          Coming Live Soon
        </h2>
        
        <p style={{ 
          fontSize: 16, 
          color: 'var(--text-secondary)', 
          lineHeight: 1.6, 
          marginBottom: 40 
        }}>
          We are working hard to bring you the <strong>{moduleName}</strong>. 
          Stay tuned for updates as we continue to enhance your project management experience!
        </p>

      </Card>
    </div>
  );
}
